/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ThumbLikeStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M7.2 21H4.8C4.13726 21 3.6 20.4627 3.6 19.8V12C3.6 11.3373 4.13726 10.8 4.8 10.8H7.2M7.2 21L15.8403 21C16.7888 21 17.6482 20.4414 18.0335 19.5747L21.0751 12.7311C21.6041 11.5407 20.7328 10.2 19.4302 10.2H13.8C13.8001 9.44517 13.8 6.04461 13.8 4.19963C13.8 3.53689 13.263 3 12.6003 3C12.3517 3 12.0753 3 11.7817 3L7.2 10.8M7.2 21V10.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { ThumbLikeStrokeIcon };
